module.exports = __webpack_public_path__ + "78ad8e60362ac1dcf02044a3e2793fc9.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/notes/notes.html
// module id = 2508
// module chunks = 0